import { useFileExport } from "@packages/core-client/downloads/useFileExport.ts";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import { i18NextInstanceKey } from "../i18n/i18next.ts";

export interface UseFormatExportResult {
    exportFile: (path: string, input: object) => Promise<boolean>;
    isExporting: boolean;
}

export function useFormatExport(fallbackFileName: string): UseFormatExportResult {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { exportFile: exportFileRaw, isExporting } = useFileExport(i18nextInstance.language);

    const exportFile = useCallback((path: string, input: object) => exportFileRaw({ path, input, fallbackFileName }), [exportFileRaw, fallbackFileName]);

    return { exportFile, isExporting };
}
